import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { Employee, EmployeePayload } from '../Employee.types';

interface Props {
  employeeId?: string;
  disabled?: boolean;
}

const useGetEmployeeByIdQuery = ({ employeeId, disabled }: Props) => {
  const enabled = Boolean(employeeId && !disabled);

  const { data, isLoading, isError, isFetching } = useQuery(
    [employeeId],
    // TODO: this type is missing
    // @ts-ignore
    () => api.get<EmployeePayload>(API_URL.UI_EMPLOYEES_BY_EMPLOYEE_ID(employeeId || '')),
    {
      enabled,
    }
  );

  const employee: Employee | undefined = useMemo((): Employee | undefined => {
    if (!data?.data || !enabled) {
      return;
    }

    return {
      // add other fields
      firstName: data?.data?.first_name,
      middleName: data?.data?.middle_name,
      lastName: data?.data?.last_name,
      fullName: `${data?.data?.first_name || ''} ${data?.data?.last_name || ''}`.trim(),
      mailingAddress: {
        line1: data?.data?.mailing_address?.line1,
        line2: data?.data?.mailing_address?.line2,
        city: data?.data?.mailing_address?.city,
        state: data?.data?.mailing_address?.state,
        zipcode: data?.data?.mailing_address?.zipcode,
        countryCode: data?.data?.mailing_address?.country_code,
        addressType: data?.data?.mailing_address?.address_type,
        undeliverable: data?.data?.mailing_address?.undeliverable,
      },
    };
  }, [data, enabled]);

  return {
    employee,
    isLoading,
    isFetching,
    isError,
  };
};

export default useGetEmployeeByIdQuery;
